export const eventActions = {
  addFromURL: 'AddFromURL',
  addFromCatalog: 'AddFromCatalog',
  addFromCampaign: 'AddFromCampaign',
  removeItem: 'RemoveItem',
  updateItem: 'UpdateItem',
}
